import InStockAlertButton from './in-stock-alert-button'

export default InStockAlertButton
